import React, { useEffect, useState } from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import { TextField, Card, Stack } from '@mui/material';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { format } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { validTime } from 'src/utils/validTime';

const BloquearNumero = (props) => {
  const { open, close, afterConfirm } = props;
  const [dateStart, setDateStart] = useState(new Date());

  const { fetch } = useFetch();
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const formik = useFormik({
    initialValues: {
      ani: '',
      fecha: format(new Date(), 'yyyy-MM-dd'),
      motivo: '',
    },
    validationSchema: Yup.object({
      ani: Yup.string()
        .max(11, 'El destino debe tener hasta 11 caracteres')
        .matches(/^56[\d]{9}$/, 'No es el formato correcto')
        .required('Este campo es obligatorio'),
      fecha: Yup.string().max(10).required('La fecha es obligatoria'),
      motivo: Yup.string().max(250).required('El motivo es obligatorio'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await fetch(`/telefonia/numeros-bloqueados`, {
          method: 'POST',
          data: { ...values },
        });
        toast.success('Número bloqueado con exito');
        afterConfirm();
        resetForm();
        /*  onCloseModal(); */
      } catch (error) {
        if (error.error === 'Conflict') {
          toast.error(error.message);
        } else {
          toast.error('No se ha podido bloquear el número');
        }
        console.error(error);
        resetForm();
      }
    },
  });

  const confirmHandler = async () => {
    if (validTime([dateStart])) {
      formik.handleSubmit();
    } else {
      toast.error('Error! Debe completar los campos con información válida');
    }
    /* try {
      await fetch(`/telefonia/numeros-bloqueados`, {
        method: 'POST',
        data: { ...formik.values },
      });
      toast.success('Número bloqueado con exito');
      afterConfirm();
      close();
    } catch (error) {
      toast.error('No se ha podido bloquear el número');
      console.error(error);
    } */
  };
  const handleDateChange = (newValue) => {
    setDateStart(newValue);
  };
  useEffect(() => {
    if (validTime([dateStart])) {
      const aux_date = format(dateStart, 'yyyy-MM-dd');
      formik.setFieldValue('fecha', aux_date);
    } else {
      formik.setFieldValue('fecha', '');
    }
    //eslint-disable-next-line
  }, [dateStart]);
  return (
    <Modal
      title={'GENERAR BLOQUEO'}
      content={
        <form onSubmit={formik.handleSubmit}>
          <Card sx={{ p: 2 }}>
            <Stack spacing={2}>
              <TextField
                size="small"
                id="ani"
                name="ani"
                label="Ani"
                placeholder={'56XXXXXXXXX'}
                value={formik.values.ani}
                onChange={formik.handleChange}
                /* inputProps={{ maxLength: 11 }} */
                error={formik.touched.ani && Boolean(formik.errors.ani)}
                helperText={formik.touched.ani && formik.errors.ani}
              />
              {/*             <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Desde"
                  value={dateStart}
                  maxDate={new Date()}
                  inputFormat="dd/MM/yyyy"
                  onChange={(newValue) => {
                    handleDateChange();
                  }}
                  renderInput={(params) => (
                    <TextField fullWidth size="small" {...params} />
                  )}
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Desde"
                  value={dateStart}
                  maxDate={new Date()}
                  inputFormat="dd/MM/yyyy"
                  onChange={(newValue) => {
                    handleDateChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField fullWidth size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
              <TextField
                size="small"
                id="motivo"
                name="motivo"
                label="Motivo"
                value={formik.values.motivo}
                onChange={formik.handleChange}
                error={formik.touched.motivo && Boolean(formik.errors.motivo)}
                helperText={formik.touched.motivo && formik.errors.motivo}
              />
            </Stack>
          </Card>
        </form>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default BloquearNumero;
